import { Grid } from '@mui/material';
import React from 'react';
import { SearchIcon } from '../../../icons/Search/SearchIcon';
import { classes, TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import CloseIcon from '@mui/icons-material/Close';

interface SearchBarProps {
  onChange: (filter: string) => void;
  className?: string;
  placeholder?: string;
  width?: 'w-full' | 'w-[320px]';
  testId?: TestIdIdentifier;
  value?: string;
  showClear?: boolean;
}

export default function SearchBar({
  onChange,
  className,
  placeholder,
  width = 'w-[320px]',
  testId,
  value,
  showClear = false,
}: SearchBarProps) {
  return (
    <Grid item xs={12} className={`${width} ${className || ''}`} data-testid={testId?.name}>
      <Grid
        container
        className={`relative flex h-[34px] w-full select-none rounded-4 border border-ventory-light-border bg-white px-1 py-1`}
      >
        <SearchIcon className='pr-2' height={'16'} width={'16'} />
        <Grid flexGrow={1} item display={'flex'}>
          <input
            data-testid={testId?.name}
            type={'text'}
            value={value}
            className={`${classes.searchBar.name} relative w-full text-[14px] font-[400] text-gray-500 !outline-none`}
            onChange={e => onChange(e.currentTarget.value)}
            placeholder={placeholder}
          />
          {showClear && value ? (
            <CloseIcon
              className='absolute right-1 top-[8px] text-gray-500 hover:cursor-pointer hover:text-black'
              onClick={() => onChange('')}
              sx={{ width: 18, height: 18 }}
            />
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}
